import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BASE_PATH = '/hyperwolf/brands';

export default function FilterBrands(props = {}) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ status: '' });
  const { applyBrandFilter } = props;

  const clearAllHandler = () => {
    setFormData({ status: '' });
    navigate(BASE_PATH);
    applyBrandFilter({});
  };

  const applyWithPayload = (status) => {
    let queryPayload = { status };
    if (queryPayload.status === 'all' || !queryPayload.status) {
      queryPayload = { ...queryPayload, status: '' };
    }
    const params = new URLSearchParams();
    if (queryPayload.status) params.set('status', queryPayload.status);
    const queryString = params.toString();
    navigate(queryString ? `${BASE_PATH}?${queryString}` : BASE_PATH);
    applyBrandFilter({ queryPayload });
  };

  const onStatusChange = (value) => {
    const next = { ...formData, status: value };
    setFormData(next);
    applyWithPayload(value);
  };

  return (
    <Box className="cus-filter-sec" mb={1}>
      <Grid className="filter-box" container alignItems="center" spacing={1.5}>
        <Grid item xs={12} sm={12} md={12} xxl={12}>
          <Box className="filter-price-unit">
            <Stack direction="row" justifyContent="flex-start" width="100%" gap={2}>
              <Grid item xs={12} sm={4} md={2} xxl={2}>
                <Box className="filter-pro-status">
                  <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                      size="small"
                      value={formData?.status || 'all'}
                      onChange={(e) => onStatusChange(e.target.value)}
                      fullWidth
                      className="form-select"
                      name="status"
                      label="Status"
                    >
                      <MenuItem value="all">All</MenuItem>
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="Inactive">Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4} md={4} xxl={1.5}>
                <Box className="filter-btns">
                  <Button
                    className="filter-clear-all"
                    onClick={clearAllHandler}
                    size="small"
                    variant="text"
                    color="secondary"
                    style={{ fontWeight: 'normal' }}
                  >
                    Clear All
                  </Button>
                </Box>
              </Grid>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
